module.exports = __webpack_public_path__ + "static/media/title_bar@3x.f70de9dd.png";